// removed by extract-text-webpack-plugin
module.exports = {"button":"_1pvrlJwfvQjCRkLDawX8cd","icon":"EsOwGM5Uv9u_yNwYlwIJT","buttonThemeDefault":"_2CE36L-oYrSWhWtBejXgYo","buttonThemePrimary":"_3WTU_z6V3D17w4qvL8aljO","buttonThemeInfo":"_2gUvK0Iuf9M1I5zJiLHrc1","buttonThemeSuccess":"_3392E8oZgTUhIc3ALeH7WL","buttonThemeWarning":"pIQjK-J9Y7gKgZDu-WEfd","buttonThemeDanger":"_1_dLXJn0aB1MG_ssloiGwY"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/00-atoms/buttons/action-button.scss
// module id = 43
// module chunks = 0